import React, { Fragment, useEffect } from 'react';
import FullUsageItem from './FullUsageItem';
import InvoiceShowFormattedMessages from '../../../../messages/billing/InvoiceShowFormattedMessages';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  Box,
} from '@mui/material';

import { invoiceTableHeader, invoiceTable } from '../../../../styles/tables';

const FullUsage = ({ fullUsageData, invoice, billDates, getDataFunction }) => {
  useEffect(() => {
    getDataFunction();
  }, [getDataFunction]);

  const generateTable = () => {
    // If do not have user usage data or users list, return message noting this
    if (!fullUsageData || fullUsageData.length === 0) {
      return (
        <Typography>{InvoiceShowFormattedMessages.NoDetailsFound}</Typography>
      );
    }

    // Otherwise create JSX data
    const data = fullUsageData.map((el, index) => {
      let key = 0;
      return (
        <Fragment key={index + 1}>
          {el.messages.map((message, messageIndex) => {
            key++;
            return (
              <FullUsageItem
                key={messageIndex}
                id={key}
                costCenter={el.cost_centre_name}
                user={message.user_name}
                date={message.date}
                time={message.time}
                phone={message.dest_tn}
                type={message.revenue_type}
                quantity={message.quantity}
                revenue={message.revenue}
                translation={message.tariff_type}
              />
            );
          })}
        </Fragment>
      );
    });

    return (
      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table width="100%" sx={invoiceTable} aria-label="full usage table">
          <TableBody>
            <TableRow>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.key}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.costCenter}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.usersName}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.date}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.time}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.phone}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.type}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.quantity}
                </Typography>
              </TableCell>
              <TableCell sx={invoiceTableHeader} align="left">
                <Typography fontWeight={700}>
                  {InvoiceShowFormattedMessages.revenue}
                </Typography>
              </TableCell>
            </TableRow>
            {data}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderContent = () => {
    if (!fullUsageData) {
      return <Typography>{InvoiceShowFormattedMessages.loading}</Typography>;
    }

    return (
      <Box>
        <Typography variant="h1" color="common.black">
          {InvoiceShowFormattedMessages.fullUsage}
        </Typography>

        <Typography component="h2" sx={{ color: 'common.black', fontSize: 18 }}>
          {`Full Usage Breakdown For: ${invoice.customerName}`}
        </Typography>
        <br />
        <Typography fontWeight={700} gutterBottom>
          {`Full usage for period ${billDates.start_date} `}
          {InvoiceShowFormattedMessages.to}
          {` ${billDates.end_date}`}
        </Typography>
        {generateTable()}
      </Box>
    );
  };

  return renderContent();
};

export default FullUsage;
